export class KeyMap {
    // #region Vars
    keys = new Map();
    // #endregion
    // #region Constructor
    constructor(object) {
        if (object) {
            Object.keys(object).forEach(e => {
                this.keys.set(e.toLowerCase(), e);
            });
        }
    }
    // #endregion
    // #region Core
    getMember(member) {
        let tMember = member.toLowerCase();
        if (!this.keys.has(tMember)) {
            return member;
        }
        else {
            return this.keys.get(tMember) ?? member;
        }
    }
}
